// extracted by mini-css-extract-plugin
export default {"TestNotificationsButton":"TestNotificationsButton_TestNotificationsButton__GQdqO"};